module.exports = __webpack_public_path__ + "img/route_1.ab88af4a.png";